import { Link } from "react-router-dom";

type CardProps = {
  title: string;
  description: string;
  thumbnail: string;
  href: string;
};

export default function Card({
  title,
  description,
  thumbnail,
  href,
}: CardProps) {
  const isExternal = href.startsWith("http");

  const content = (
    <article
      style={{
        border: "1px solid #ddd",
        borderRadius: 16,
        overflow: "hidden",
        background: "#fff",
        height: "100%",
      }}
    >
      <img
        src={thumbnail}
        alt={title}
        style={{
          width: "100%",
          height: 200,
          objectFit: "cover",
          display: "block",
          background: "#f5f5f5",
        }}
      />

      <div style={{ padding: 20 }}>
        <h3 style={{ fontSize: 22, margin: "0 0 10px" }}>{title}</h3>

        <p
          style={{
            color: "#555",
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          {description}
        </p>
      </div>
    </article>
  );

  if (isExternal) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        style={{ color: "inherit", textDecoration: "none" }}
      >
        {content}
      </a>
    );
  }

  return (
    <Link to={href} style={{ color: "inherit", textDecoration: "none" }}>
      {content}
    </Link>
  );
}
